var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 4.88889H8.26667C6.77319 4.88889 6.02645 4.88889 5.45603 5.17954C4.95426 5.4352 4.54631 5.84314 4.29065 6.34491C4 6.91534 4 7.66208 4 9.15555V15.7333C4 17.2268 4 17.9735 4.29065 18.544C4.54631 19.0458 4.95426 19.4537 5.45603 19.7093C6.02645 20 6.77319 20 8.26667 20H14.8444C16.338 20 17.0846 20 17.6551 19.7093C18.1569 19.4537 18.5648 19.0458 18.8204 18.544C19.1111 17.9735 19.1111 17.2268 19.1111 15.7333V12.8889M12.8889 16.4444H7.55556M14.6667 12.8889H7.55556M19.2189 4.78105C20.2604 5.82244 20.2604 7.51089 19.2189 8.55228C18.1775 9.59368 16.4892 9.59368 15.4477 8.55228C14.4063 7.51089 14.4063 5.82244 15.4477 4.78105C16.4892 3.73965 18.1775 3.73965 19.2189 4.78105Z",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationText);
export default __webpack_public_path__ + "static/media/notification-text.56bc02645b91c48a2eda6d57bf21798f.svg";
export { ForwardRef as ReactComponent };